export default __webpack_public_path__ + "static/media/Bottleguard.2026eb7e.jpg";